import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { EnumLabelService } from '../enum-label/enum-label.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { Notification } from '../../interfaces/notification';
import { eOrderType } from '../../enums';
import { trackedEntityDisplayName } from '../../alert-display';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notifications: Notification[] = [];
  private notificationsSubject = new BehaviorSubject<Notification[]>([]);
  notifications$ = this.notificationsSubject.asObservable();

  private nextId = 0;
  private readonly transloco = inject(TranslocoService);
  private readonly enumLabels = inject(EnumLabelService);

  constructor() {}

  addNotification(notification: Notification) {
    this.formatNotification(notification);

    this.notifications.push(notification);
    this.notificationsSubject.next(this.notifications); // Emit the updated notifications array

    // Optionally, remove the notification after a certain time
    setTimeout(() => {
      this.removeNotification(notification.id!);
    }, 15000); 
  }

  removeNotification(id: number) {
    this.notifications = this.notifications.filter(n => n.id !== id);
    this.notificationsSubject.next(this.notifications); // Emit the updated notifications array
  }

  formatNotification(notification: Notification) {
    notification.id = this.nextId++;

    if(notification.order) {
      if(!notification.header) {
        notification.header = this.transloco.translate('notifications.orderCompleteHeader');
      }
      
      if(!notification.body) {
        notification.body = this.transloco.translate('notifications.orderCompleteBody');
      }
    }

    if(notification.alert) {
      const alert = notification.alert;

      if(!notification.header) {
        notification.header = this.transloco.translate('notifications.newAlertHeader', { severity: this.enumLabels.label('alertSeverity', alert.alertSeverityID) });
      }

      if(!notification.body) {
        const subject = trackedEntityDisplayName(alert.trackedAlertEntity);
        notification.body = subject ? `${subject}: ${alert.description}` : alert.description;
      }
    }
  }
}
